import { PropsWithChildren } from 'react';
import { Edit } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';

interface Props {
  onClick: () => void;
  disabled?: boolean;
  isMobile?: boolean;
}
export const LabelEdit = ({ children, onClick, disabled, isMobile = false }: PropsWithChildren<Props>) => (
  <Box
    display="flex"
    alignItems="center"
    gap={1}
    height={20}
    sx={{
      cursor: 'pointer',
    }}
  >
    <Box
      sx={{
        maxWidth: 200,
        '.MuiTypography-root': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
      }}
    >
      {children}
    </Box>
    {(Boolean(isMobile && disabled) == false) && (
      <IconButton disabled={disabled} onClick={onClick} size="small">
        <Edit fontSize="small" />
      </IconButton>
    )}
  </Box>
);
